export const CLIENT_LOGIN_PATH = '/clientes/login';
export const CLIENT_PORTAL_PATH = '/clientes';

export const ADMIN_EMAILS = ['info@datados.es'];

// TODO: Sustituir por el dominio real antes de dar acceso a esta cuenta.
export const SAYBIC_PENDING_EMAIL =
  'victor.cabrera.deleon@PENDIENTE_COMPLETAR';

export const CLIENTS = {
  motowebLasPalmas: {
    id: 'motoweb-las-palmas',
    name: 'MotoWeb Las Palmas',
    description: 'Rendimiento orgánico y analítica de contenidos',
    path: '/clientes/motoweb-las-palmas',
    authorizedEmails: [
      'info@datados.es',
      'info@motoweblaspalmas.com'
    ]
  },
  saybicInnovation: {
    id: 'saybic-innovation',
    name: 'SayBiC Innovation',
    description: 'Dashboard comercial y analítica de ventas',
    path: '/clientes/saybic-innovation',
    authorizedEmails: [
      'info@datados.es',
      'victor@datados.es',
      SAYBIC_PENDING_EMAIL
    ]
  }
};

const normalizeEmail = (email = '') => email.trim().toLowerCase();

export const isAdmin = (user) => {
  if (!user?.email) {
    return false;
  }

  const userEmail = normalizeEmail(user.email);
  return ADMIN_EMAILS.some((email) => normalizeEmail(email) === userEmail);
};

export const isAuthorizedForClient = (user, client) => {
  if (!user?.email || !client) {
    return false;
  }

  if (isAdmin(user)) {
    return true;
  }

  const userEmail = normalizeEmail(user.email);
  return client.authorizedEmails.some(
    (email) => normalizeEmail(email) === userEmail
  );
};

export const getDefaultClientPath = (user) => {
  if (isAdmin(user)) {
    return CLIENT_PORTAL_PATH;
  }

  const client = Object.values(CLIENTS).find((item) =>
    isAuthorizedForClient(user, item)
  );

  return client?.path ?? null;
};

// La autorización por email en el frontend es una primera versión. Para una
// protección robusta debe validarse con custom claims de Firebase o en backend.
